// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"760bfb0d","239":"0dcabb4c","453":"6fc37093","455":"ba2993e9","486":"8a3ba41a","977":"a8b76e22"}[chunkId] + ".chunk.js";
};